import { combine, createStore, sample } from 'effector';
import { createGate } from 'effector-react';
import { createRoute, type RouteInstance } from 'atomic-router';

import { calendarRoute, mentoringRoute, processRoute, productListRoute } from 'shared/routes';
import { $canViewMentorAdaptationProcesses, $canViewTeamPage } from 'entities/currentUser';
import { getCurrentTodosFx } from 'features/todoList';
import { $todos } from 'widgets/todoWidget';

export const routeFromSidebarToBlocks = createRoute();
export const routeFromSidebarToVacancies = createRoute();
export const routeFromLogoToStructure = createRoute();
export const routeFromSidebarToSalaryRequest = createRoute();

export const SidebarGate = createGate();

export enum LinkType {
  External = 'External',
  Internal = 'Internal',
}

type LinkTitle = 'vacancies' | 'requestSalary' | 'blocks' | 'products' | 'processRoute' | 'calendar' | 'mentor';

type InternalLink = {
  name: string;
  title: LinkTitle;
  type: LinkType.Internal;
  to: RouteInstance<Record<PropertyKey, unknown>>;
};

type ExternalLink = {
  name: string;
  title: LinkTitle;
  type: LinkType.External;
  to: string;
};

type MenuItem = ExternalLink | InternalLink;

export const menuItems: MenuItem[] = [
  {
    name: 'Структура',
    title: 'blocks',
    type: LinkType.Internal,
    to: routeFromSidebarToBlocks,
  },
  {
    name: 'Вакансии',
    type: LinkType.Internal,
    title: 'vacancies',
    to: routeFromSidebarToVacancies,
  },
  {
    name: 'Заявка на ЗП',
    type: LinkType.Internal,
    title: 'requestSalary',
    to: routeFromSidebarToSalaryRequest,
  },

  {
    name: 'Продукты',
    type: LinkType.Internal,
    title: 'products',
    to: productListRoute,
  },
  //
  {
    name: 'События',
    type: LinkType.Internal,
    title: 'calendar',
    to: calendarRoute,
  },
];

export const $menuItems = combine(
  {
    base: createStore(menuItems),
    canViewTeamPage: $canViewTeamPage,
    canViewMentor: $canViewMentorAdaptationProcesses,
  },
  ({ base, canViewTeamPage, canViewMentor }) => {
    const result = [...base];
    if (canViewTeamPage) {
      result.push({
        name: 'Команда',
        title: 'processRoute',
        type: LinkType.Internal,
        to: processRoute,
      });
    }
    if (canViewMentor) {
      result.push({
        name: 'Я наставник',
        type: LinkType.Internal,
        title: 'mentor',
        to: mentoringRoute,
      });
    }

    return result;
  }
);

export const $routesOpenState = combine(
  {
    blocks: routeFromSidebarToBlocks.$isOpened,
    vacancies: routeFromSidebarToVacancies.$isOpened,
    requestSalary: routeFromSidebarToSalaryRequest.$isOpened,
    processRoute: processRoute.$isOpened,
    calendar: calendarRoute.$isOpened,
    products: productListRoute.$isOpened,
    mentor: mentoringRoute.$isOpened,
  },
  (routesOpenState) => routesOpenState as Record<LinkTitle, boolean>
);

sample({
  clock: SidebarGate.open,
  source: $todos,
  filter: ($todos) => !$todos?.tasks.length,
  target: getCurrentTodosFx,
});
